import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { envAwarePost } from "../../util/util"
import Card from "react-bootstrap/esm/Card";
import ListGroup from "react-bootstrap/ListGroup"
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { getAllActivePostsByAddress, selectAllActivePosts, getTrainerId, getSinglePost, getPostComments, createComment } from "../../state/blogSlice";
import CenteredLoader from "../CenteredLoader/CenteredLoader"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import BlogAddEdit from "./BlogAddEdit";
import LiveViewSidebar from "./LiveViewSidebar";
import { useParams } from "react-router";
import parse from 'html-react-parser';
import { fullBasePath } from "../../util/util"
import styles from './Blog.module.css'
import DOMPurify from 'dompurify';



function SingleBlog() {
    let statusDispatch = useApiStatusDispatch();
    let dispatch = useDispatch();
    let { pageAddress } = useParams();
    let { postSlug } = useParams();

    const post = useSelector(state => state.posts.singlePost);
    const getSinglePostLoading = useSelector(state => state.posts.getSinglePostLoading);

    const getCommentsLoading = useSelector(state => state.posts.getCommentsLoading);

    const comments = useSelector(state => state.posts.postComments);
    const user_id = useSelector(state => state?.users?.current_user?.user_id);
    const user_name = useSelector(state => state?.users?.current_user?.user_name);
    const [commentLoading, setCommentLoading] = useState(false);
    const [comment, setComment] = useState("");
    const [isCommenting, setIsCommenting] = useState(false)

    useEffect(() => {
        let payload = {
            pageAddress,
            post_slug: postSlug,
            action: "getSinglePost"
        }
        dispatch(getSinglePost(payload))
            .then(res => {
                if (res.payload.success === "1") {
                    let post_id = res.payload.data.post.post_id
                    let payload = {
                        pageAddress,
                        post_id,
                        action: "getPostComments"
                    }
                    dispatch(getPostComments(payload))
                }
            })
    }, [])

    function handleCommentSubmit() {
        let payload = {
            comment,
            post_id: post.post_id,
            user_id,
            user_name,
            action: "createComment"
        }
        setCommentLoading(true)
        statusDispatch(createComment(payload), "comment", "create")
            .then((res) => {
                setCommentLoading(false);
                setComment("")
                setIsCommenting(false)
            })
    }

    return (
        <div>
            <>
                <Row
                    className="mx-0 px-0"
                    style={{
                        backgroundColor: "#f7f8f9",
                        padding: "50px",
                        boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                        borderRadius: "5px"
                    }}
                >
                    <Col className="mx-0 px-5" lg={8}>
                        {!getSinglePostLoading ? <>

                            <div className="text-center mb-0"> <h1 style={{ textTransform: "capitalize" }}> {post.post_title} </h1></div>
                            <hr style={{ color: "black" }} className="mb-3" />
                            <div className="mb-3">
                                <i><span class="far fa-clock"></span> Published on {post.date_added}</i>
                            </div>
                            <Card
                                className="p-3"
                                style={{
                                    background: "#ffffff",
                                    border: "2px",
                                    borderRadius: '10px',
                                    boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                                    maxWidth:'88vw'
                                }}>


                                <div className={styles.postBodyDiv}>
                                    {
                                        parse(DOMPurify.sanitize(post.post_body))
                                        //parse(post.post_body.slice(0,150) + "...")
                                    }
                                </div>
                            </Card>
                            <h5 className="mt-4 w-25 mb-3"
                                style={{
                                    borderBottom: "1px solid grey",
                                    paddingBottom: "10px",

                                }}
                            > <b> <i> Comments </i> </b> </h5>

                            <div
                                style={{
                                    backgroundColor: "rgb(255 255 255)",
                                    padding: "20px 50px",
                                    boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                                    borderRadius: "5px",
                                    marginBottom: "20px"
                                }}>

                                {getCommentsLoading ?
                                    <Spinner variant="primary" animation="border" /> :
                                    comments?.length > 0 ? comments.map(comment => {
                                        return (
                                            <div className="mb-3">
                                                <div> <b> {comment.user_name} </b> </div>
                                                <div className="text-secondary"> <small> <span class="far fa-clock"></span> posted on {comment.date_added} </small></div>
                                                <div className="mt-1"> {comment.comment} </div>
                                                <div className="pb-2"
                                                    style={{
                                                        borderBottom: "2px solid #8f8f8f"

                                                    }}> </div>
                                            </div >
                                        )
                                    }) : <div className="">
                                        No comments
                                    </div>
                                }
                            </div>

                            <div>
                                {/* {!isCommenting ? 
                                    <Button onClick={() => setIsCommenting(true)}>Comment</Button>
                                    : 
                                    } */}
                                <Form.Group>
                                    {user_id ?
                                        <>
                                            {!isCommenting ? 
                                                <Button onClick={() => setIsCommenting(true)} variant="outline-success">Comment</Button>
                                            : 
                                                <>
                                                    <Form.Label> <i> Leave a Comment </i></Form.Label>
                                                    <textarea
                                                        value={comment}
                                                        rows={5}
                                                        className="d-block w-100"
                                                        onChange={(e) => {
                                                            setComment(e.target.value);
                                                        }} > </textarea>
                                                    <Button className="mt-2" onClick={handleCommentSubmit} variant="success">
                                                        {commentLoading ? <Spinner size="sm" animation="border" /> : <span> Submit </span>}
                                                    </Button>
                                                </>
                                            }
                                        </>
                                        :

                                        <a href={`${fullBasePath()}/signin`} style={{textDecoration:"none"}}>
                                            <Button className="d-block" >
                                                Sign in to comment
                                            </Button>
                                        </a>

                                    }
                                </Form.Group>
                            </div>
                        </> : <CenteredLoader />}
                    </Col>
                    <LiveViewSidebar />
                </Row>
            </>
        </div >
    )

}
export default SingleBlog;
